module.exports = __webpack_public_path__ + "img/banner.5752149e.jpg";